import axiosInstance from './api';

const apiErrorHandler = e => {
  if (e.response && e.response.data && e.response.data.message) {
    throw new Error(e.response.data.message);
  } else if (e.message) {
    throw e;
  } else {
    throw new Error('Unexpected error occured when calling api. Please contact admin.');
  }
};

export const submitEnquiry = enquiryBody => {
  return axiosInstance
    .post('/external/enquiry', enquiryBody)
    .then(res => {
      return res;
    })
    .catch(apiErrorHandler);
};
